import { ICryptoCoin, ICryptoPrices, COIN_TICKER, CURRENCY_FILTER } from './../../../models/Crypto';
import { Component, DoCheck, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { AuthService } from '../../../abstraction/auth.service';
import { CryptoService } from '../../../abstraction/crypto.service';
import { DataLayerService } from '../../../services/utils/data-layer.service';
import { IOrderStatus } from '../../../models/Order';

@Component({
  selector: 'app-crypto-exchange',
  templateUrl: './crypto-exchange.component.html',
  styleUrls: ['./crypto-exchange.component.scss'],
})
export class CryptoExchangeComponent implements OnInit, DoCheck {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  CURRENCY_FILTER = CURRENCY_FILTER;
  currency: CURRENCY_FILTER = CURRENCY_FILTER.ARS;
  stableCryptos: ICryptoCoin[];
  classicCryptos: ICryptoCoin[];
  popularCryptos: ICryptoCoin[];
  volatilCryptos: ICryptoCoin[];
  allCryptos: ICryptoCoin[];
  exchangeCardOpened = false;
  detailCardOpened = false;
  isArsCurrency = true;
  isExchange = true;
  searching = false;
  selectedCoin: ICryptoCoin;
  selectedCrypto = '';
  selectedSection = '';
  cryptoPrices: ICryptoPrices = {};
  ordersStatus: IOrderStatus;
  currentUrl = '';
  emptyCoins = false;

  constructor(
    public authService: AuthService,
    public dataS: DataLayerService,
    public confirmDialog: MatDialog,
    private cryptoService: CryptoService,
    public router: Router,
    public api: ApiService,
    public route: ActivatedRoute, // public tycS: TycService
  ) {}

  @HostListener('window:keydown', ['$event'])
  clickout(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.onCloseCryptoCard();
    }
  }

  ngOnInit(): void {
    this.authService.sendTikTokPageView(window.location.href).subscribe();
    const balanceCrypto = this.authService.loggedUser.balance.crypto;
    this.cryptoService.stableCryptos.subscribe((stableCoins) => {
      this.stableCryptos = stableCoins
        .filter((coin) => coin.ticker !== 'BUSD')
        .sort((a, b) => {
          if (a.ticker === COIN_TICKER.USDT) return -1;
        });
    });
    this.cryptoService.volatilCryptos.subscribe((volatilCoins) => {
      this.volatilCryptos = volatilCoins
        .filter(
          // Ocultado manual, ver lista en hiddenCoinPairs en crypto.service
          (coin) =>
            (!this.cryptoService.isHiddenInMarket(coin.symbol) ||
              Object.keys(balanceCrypto).includes(coin.ticker)) &&
            !(coin.symbol === 'NUARS_ARS' && !this.authService.loggedUser?.isCommerce),
        )
        .sort((a, b) => {
          // Custom sort para que quede BTC -> ETH -> BNB
          if (a.ticker === COIN_TICKER.BTC) return -1;
          if (a.ticker === COIN_TICKER.ETH) return 0;
          if (a.ticker === COIN_TICKER.BNB) return 1;
        });
    });
    this.route.data.subscribe((data) => (this.isExchange = data.isExchange));
    this.cryptoService.prices.subscribe((prices) => {
      this.cryptoPrices = prices;
    });

    this.cryptoService.getOrdersStatus().subscribe((res) => {
      this.ordersStatus = res;
    });
  }

  ngDoCheck() {
    if (this.currency !== this.cryptoService.currentCurrency) {
      this.currency = this.cryptoService.currentCurrency;
    }
    this.checkUrl();
  }

  cryptoSearch(searchResults: ICryptoCoin[][]) {
    const [stableCryptosSearch, volatilCryptosSearch] = searchResults;
    this.stableCryptos = stableCryptosSearch.filter((coin) => coin.ticker !== 'BUSD');
    this.volatilCryptos = volatilCryptosSearch.filter(
      // Ocultado manual, ver lista en hiddenCoinPairs en crypto.service
      (coin) =>
        !this.cryptoService.isHiddenInMarket(coin.symbol) &&
        !(coin.symbol === 'NUARS_ARS' && !this.authService.loggedUser?.isCommerce),
    );
    this.emptyCoins = this.stableCryptos.length === 0 || this.volatilCryptos.length === 0;
  }

  cryptoCardClicked(symbol: string) {
    if (
      this.allCryptos.filter((crypto) => crypto.symbol === symbol)[0].active &&
      !this.exchangeCardOpened
    ) {
      this.exchangeCardOpened = true;
      this.selectedCrypto = symbol;
    }
  }

  getCryptoListByCurrency(list: ICryptoCoin[]) {
    return list.filter((crypto) => crypto.currency === this.currency && crypto.ticker !== 'LUNA2');
  }

  onCloseCryptoCard() {
    this.router.navigateByUrl(`/crypto-exchange`);
    this.selectedCrypto = '';
    this.selectedSection = '';
  }

  changeMode(mode: string) {
    if (mode === 'exchange') {
      this.isExchange = true;
      this.router.navigate(['core', 'crypto-exchange']);
    } else {
      this.isExchange = false;
      this.router.navigate(['core', 'crypto-staking']);
    }
  }

  selectCoinCard(crypto: ICryptoCoin) {
    this.selectedCoin = crypto;
    const ticker = crypto.ticker === 'UST' ? 'USTC' : crypto.ticker;
    this.router.navigateByUrl(`/crypto-exchange/${ticker}`);
  }

  getPrices(crypto: ICryptoCoin) {
    let ticker = crypto.symbol;
    if (ticker === 'LUNC') {
      ticker = 'LUNA';
    } else if (ticker === 'USTC') {
      ticker = 'UST';
    } else if (ticker === 'LUNA') {
      ticker = 'LUNA2';
    }
    return this.cryptoPrices[ticker];
  }

  changeCurrency(currency: CURRENCY_FILTER) {
    this.cryptoService.currentCurrency = currency;
    this.currency = this.cryptoService.currentCurrency;
  }

  checkUrl() {
    if (this.currentUrl !== this.router.url) {
      this.currentUrl = this.router.url;
      this.hiddenOrShowExchange();
    }
  }

  hiddenOrShowExchange() {
    let checkRoute: string[] = this.currentUrl.split('/');
    if (checkRoute[2]) {
      this.exchangeCardOpened = true;
    } else {
      this.exchangeCardOpened = false;
    }
  }
}
